(function () {
    'use strict';

    angular
        .module('app.layout')
       
        .factory('carousel.dialog', carouselDialog);

    carouselDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];
    /* @ngInject */
    function carouselDialog($modal, $templateCache, opsIncludeVersion) {
        var service = {
            display: display
        }
        
        $templateCache.put('carouselDialog.tpl.html?v=' + opsIncludeVersion,
             '<div>' +
             '    <div class="modal-header">' +
             '        <button type="button" class="close" data-dismiss="modal" ' +
             '            aria-hidden="true" data-ng-click="cancel()">&times;</button>' +
             '        <h3>Attachments</h3>' +
             '    </div>' +
             '    <div class="modal-body">' +
             '      <div uib-carousel interval="interval" active="active" on-carousel-change="onSlideChanged(nextSlide, direction)" >' +
             '          <div uib-slide ng-repeat="slide in items " index="slide.index" >' +
             '          <img data-ng-src="{{::slide.Url}}" style="margin:auto;" data-ng-show="::isExternalLink(slide)" />' +
             '          <img data-ng-src="data:image/png;base64,{{::slide.Base64Data}}" style="margin:auto;max-width:100%" data-ng-show="::isImage(slide)" />' +
             '          <div style="margin:auto;" data-ng-show="::isOther(slide)" >' +
             '          <h4>{{::slide.FileName}}</h4><br /><span>File type not supported at this time</span> ' +
             '          </div>' +
             '          <div class="carousel-caption">' +
             '              <h4>{{::slide.Description}}</h4>' +
             '              <p>{{::slide.Notes}}</p>' +
             '          </div>' +
             '           </div>' +
             '       </div>' +
             '       <div class="text-center" id="pdfView"></div>' +

             '    </div>' +
             '    <div class="modal-footer">' +
                '        <button class="btn btn-primary" data-ng-click="ok()"><i class="fa fa-save"></i>{{okText}}</button>' +
                '    </div>' +
             '</div>');

        return service;


        function display(slides, interval) {
            for (var i = 0; i < slides.length; i++) {
                slides[i].index = i;
            }
            
            var modalOptions = {
                templateUrl: 'carouselDialog.tpl.html?v=' + opsIncludeVersion,
                controller: CarouselModalInstance,
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            slides: slides,
                            interval: interval
                        };
                    }
                }
            };

            return $modal.open(modalOptions).result;
        }
    }


    CarouselModalInstance.$inject = ['$scope', '$uibModalInstance', '$sce', 'options', 'fileDownloader'];

        /* @ngInject */
    function CarouselModalInstance($scope, $modalInstance, $sce, options, downloader) {
        
        $scope.okText = 'Close';
        $scope.items = options.slides;
        if (options.slides.length > 1) {
            $scope.interval = options.interval || 0;
        }
        else {
            $scope.interval = 0;
        }
        
        $scope.active = 0;

        $scope.ok = function () {
            $modalInstance.close('ok');
        };
        $scope.cancel = function () {
            $modalInstance.close('cancel');
        };
       
        $modalInstance.opened.then(function () {
          //  if ($scope.isPdf(options.slides[0])) {
          //      $scope.showPdf(options.slides[0]);
          //  }
        }, function (error) { });

        $scope.onSlideChanged = function (nextSlide, direction) {
            
            var node = document.getElementById('pdfView');
            while (node.hasChildNodes()) {
                node.removeChild(node.lastChild);
            }

            var currentSlideIndex = $scope.active;
            if (direction) {
                if (direction == "next") {
                    if ((currentSlideIndex + 1) == $scope.items.length) {
                        currentSlideIndex = 0;
                    }
                    else {
                        currentSlideIndex += 1;
                    }
                }
                else {
                    if ((currentSlideIndex - 1) < 0) {
                        currentSlideIndex = $scope.items.length;
                    }
                    else {
                        currentSlideIndex -= 1;
                    }
                }
            }

            var slide = $scope.items[currentSlideIndex];
            
            if (slide && $scope.isPdf(slide)) {
                $scope.showPdf(slide);
            }
        }

        $scope.isOther = function (slide) {
            return $scope.isImage(slide) == false && $scope.isPdf(slide) == false;
        }

        $scope.downloadFile = function (slide) {
            
            if (slide) {
                if (slide.StoredFile) {
                    var bytes = window.atob(slide.StoredFile);
                    
                    downloader.download(bytes, "application/octet-stream", slide.FileName);
                }
            }
            //console.log(slide)
        }

        function _endsWith(str, suffix) {
            return str.match(suffix + "$") == suffix;
        }

        $scope.isImage = function (slide) {
            if (slide) {
                if (slide.FileName) {
                    var fn = slide.FileName.toLowerCase();
                    if (
                        _endsWith(fn, ".png") || _endsWith(fn, ".bmp")
                        || _endsWith(fn, ".gif") || _endsWith(fn, ".jpg")
                        || _endsWith(fn, ".jpeg") || _endsWith(fn, ".ico")
                        || _endsWith(fn, ".tif") || _endsWith(fn, ".tiff")
                        || _endsWith(fn, ".svg")) {
                        return true;
                    }
                }
            }
            return false;
        }

        $scope.isExternalLink = function (slide) {
            if (slide.Url) {
                return true;
            }
            return false
        }

        $scope.isPdf = function (slide) {
            if (slide) {
                if (slide.FileName) {
                    if (_endsWith(slide.FileName.toLowerCase(), ".pdf")) {
                        return true;
                    }
                }
            }
            return false;
        }

        $scope.showPdf = function (slide) {
            var b = window.atob(slide.StoredFile);
            
            var loadingTask = pdfjsLib.getDocument({ data: b });
            loadingTask.promise.then(function(pdf) {
                _thePdf = pdf;
                _numPages = pdf.numPages
                pdf.getPage(1).then(_handlePages, function (error) { console.log(error) });
            });
            
        }



        var _currPage = 1;
        var _numPages = 0;
        var _thePdf = null;
        function _handlePages(page) {
            var  scale  = 1.2;
            var canvas = document.createElement("canvas");
            var context = canvas.getContext('2d');
            var viewport = page.getViewport( scale);
            var outputScale = window.devicePixelRatio || 1;
            canvas.width = Math.floor(viewport.width * outputScale);
            canvas.height = Math.floor(viewport.height * outputScale);
            canvas.style.width = Math.floor(viewport.width) + "px";
            canvas.style.heigth = Math.floor(viewport.height) + "px";
            var transform = outputScale !== 1
                ? [outputScale, 0, 0, outputScale, 0, 0]
                : null;

            var renderContext = {
                canvasContext: context,
                transform: transform,
                viewport: viewport
            }
            page.render(renderContext);
            var appendTo = document.getElementById('pdfView');
            if (appendTo) {
                appendTo.appendChild(canvas);
            }
            _currPage++;

            if (_thePdf !== null && _currPage <= _numPages) {
                _thePdf.getPage(_currPage).then(_handlePages, function (error) { });
            }

            /*
            var viewport = page.getViewport(1);
            var canvas = document.createElement("canvas");
            canvas.style.display = "block";
            var context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            page.render({ canvasContext: context, viewport: viewport });
            var appendTo = document.getElementById('pdfView');
            if (appendTo) {
                appendTo.appendChild(canvas);
            }


            _currPage++;
            
            if (_thePdf !== null && _currPage <= _numPages) {
                _thePdf.getPage(_currPage).then(_handlePages, function (error) { });
            }
            */
        }

    }
})();
